import EventEmitter from "eventemitter3";

const eventEmitter = new EventEmitter();

const Emitter = {
  on: (event, fn) => eventEmitter.on(event, fn),
  once: (event, fn) => eventEmitter.once(event, fn),
  off: (event, fn) => eventEmitter.off(event, fn),
  emit: (event, payload) => eventEmitter.emit(event, payload),
};

Object.freeze(Emitter);

export default Emitter;

export const EventTypes = {
  INVALID_TOKEN: "INVALID_TOKEN",
  REMOVE_ASSESSMENT: "REMOVE_ASSESSMENT",
  NTN_LOGIN_SUCCESS: "NTN_LOGIN_SUCCESS",
  NTN_LOGIN_INVALID: "NTN_LOGIN_INVALID",
  NTN_LOGOUT_SUCCESS: "NTN_LOGOUT_SUCCESS",
  NTN_TOKEN_FAILURE: "NTN_TOKEN_FAILURE",
};
